module.exports = __webpack_public_path__ + "img/donante-moka.6a8fbbf6.png";